import { useState } from 'react'
/*
* const { loading: questionLoading, startLoading: startQuestionLoading } = useFakeLoading()
* startLoading()
*/
const useFakeLoading = (delay = 300) => {
  const [loading, setLoading] = useState(false)
  const [timeoutKey, setTimeoutKey] = useState()
  const startLoading = () => {
    setLoading(true)
    clearTimeout(timeoutKey)
    setTimeoutKey(setTimeout(() => {
      setLoading(false)
    }, delay))
  }
  return { loading, startLoading }
}

export default useFakeLoading